// extracted by mini-css-extract-plugin
export default {"loadingMain":"customLoading_loadingMain__Pwy4v"};